export default "__VITE_ASSET__Cwj7pAoy__"